export default __webpack_public_path__ + "static/media/inbox.4ed822ba.svg";